import(/* webpackMode: "eager" */ "/app/app/mycart/page.tsx");
